module.exports = __webpack_public_path__ + "img/groupIcon4.dee9bc97.jpg";